import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import HomeFull from '@/components/HomeFull'
import Characters from '@/components/Characters'
import Production from '@/components/Production'
import Trailer from '@/components/Trailer'
import Photos from '@/components/Photos'
import Downloads from '@/components/Downloads'
import Contact from '@/components/Contact'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeFull
    },
    {
      path: '/characters',
      name: 'Characters',
      component: Characters
    },
    {
      path: '/production',
      name: 'Production',
      component: Production
    },
    {
      path: '/trailer',
      name: 'Trailer',
      component: Trailer
    },
    {
      path: '/photos',
      name: 'Photos',
      component: Photos
    },
    {
      path: '/downloads',
      name: 'Downloads',
      component: Downloads
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '*',
      redirect: {
        name: 'Home'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js